import { Apps } from '@/constants/apps';

const SOCIAL_LINKS: Record<Apps, Record<string, string>> = {
  homescapes: {
    facebook: 'https://www.facebook.com/homescapes',
    instagram: 'https://www.instagram.com/homescapes_mobile',
    vk: 'https://vk.com/gamehomescapes',
    twitter: 'https://twitter.com/homescapes',
  },
  township: {
    facebook: 'https://www.facebook.com/TownshipMobile',
    instagram: 'https://www.instagram.com/township_mobile/',
    twitter: 'https://twitter.com/township_mobile',
  },
};
export default SOCIAL_LINKS;
